import { openInBlobInBlank } from "../../../../../common/utils/view_utils";
import { IVisualizeObraDocumentoUseCase } from "../../../presentation/useCases/read/visualize_obra_documento_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * VisualizeObraDocumentoUseCase
 */

export class VisualizeObraDocumentoUseCase implements IVisualizeObraDocumentoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async visualizeObraDocumento(
    idObraArquivo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const response = await this.repository.downloadObraDocumento(idObraArquivo);
    await openInBlobInBlank(nomeArquivo, response);
  }
}
